import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {NzModalService} from 'ng-zorro-antd/modal';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {
  DeleteStatus,
  exportAsExcelFile,
  formatDataExport,
  formatFilter,
  ItemMode, ListOperate,
  ListStatus,
  MasterDataStatus,
  REGEX,
  SharedService
} from '../../../shared/shared.service';
import {ItemComponent} from '../item/item.component';
import {ProxyDynamicService} from '../../../shared/service/proxy-dynamic.service';
import {DatePipe} from '@angular/common';
import moment from 'moment';
import {forkJoin, map} from "rxjs";
import { ColumnConfigExport } from '../../../shared/models/config-export.model';

@Component({
  selector: 'app-country',
  templateUrl: './list.component.html',
  styleUrl: './list.component.scss',
  providers: [DatePipe]
})
export class ListComponent implements OnInit {
  listStatus = ListStatus;
  listOperate = ListOperate;
  formConfig: any[] = [
      {name: 'code', title: 'country.code', default: null,  type: 'textAsLink', max: 25, col: 12, required: true, sortBy: 'ASC'},
      {name: 'name', title: 'country.name', default: null, type: 'text', max: 200, col: 12, required: true, sortBy: 'ASC'},
      {name: 'full_name', title: 'country.name', default: null, type: 'text', max: 200, col: 12, required: true, sortBy: 'ASC'},
      {name: 'status', title: 'status.title', default: MasterDataStatus.Active, type: 'status', col: 12, options: this.listStatus, required: true, sortBy: 'ASC'},
      {name: 'creator', title: 'creator', default: null, type: 'text', col: 12, viewOnly: true},
      {name: 'date_created', title: 'created', default: moment().set({h: 0, m: 0, s: 0, ms: 0}).toDate(), type: 'date', col: 12, viewOnly: true, format: 'DD/MM/YYYY hh:mm:ss', showTime: true},
      {name: 'updater', title: 'updater', default: null, type: 'text', col: 12, viewOnly: true},
      {name: 'date_updated', title: 'updated', default: moment().set({h: 0, m: 0, s: 0, ms: 0}).toDate(), type: 'date', col: 12, viewOnly: true, format: 'DD/MM/YYYY hh:mm:ss', showTime: true},
    ];
    formFilterConfig = [
      {name: 'code', title: 'country.code', default: '', type: 'text', col: 8},
      {name: 'name', title: 'country.name', default: '', type: 'text', col: 8},
      {name: 'status', title: 'status.title', default: MasterDataStatus.Active, type: 'status', col: 8, options: this.listStatus},
    ];
  filter: any = {
    limit: 15,
    page: 0,
    sort: '-code',
    code: null,
    name: null,
    package_id: null,
    operation_type: null,
    apartment_type: null,
    status: MasterDataStatus.Active
  };
  source: any[] = [];
  totalRows: number = 0;

  constructor(
    private translate: TranslateService,
    private modalService: NzModalService,
    private noti: NzNotificationService,
    private service: ProxyDynamicService,
    private datePipe: DatePipe,
    private sharedService: SharedService,
  ) {
  }

  ngOnInit() {
    this.getData();
  }

  getData(event?: any) {
    this.sharedService.showLoading(true);
    if (event) {
      Object.keys(event).forEach((key: any) => {
        this.filter[key] = event[key];
      })
    }
    this.service.searchWithMeta('country', {
      fields: ['*', 'user_created.*', 'user_updated.*'],
      filter: formatFilter(this.filter, this.formFilterConfig),
      "limit": this.filter.limit,
      "page": this.filter.page,
      'sort': [this.filter['sort']]
    }).then(res => {
      this.totalRows = res.total;
      this.source = res?.data?.map(item => {
        item['creator'] = item['user_created'] ? [item['user_created']['first_name'], item['user_created']['last_name']].join(' ') : undefined;
        item['updater'] = item['user_updated'] ? [item['user_updated']['first_name'], item['user_updated']['last_name']].join(' ') : undefined;
        return item;
      });
      this.sharedService.showLoading(false);
    }).catch((error: any) => {
      this.service.handleError(error)
    });
  }

  onChangePage(event: any) {
    this.filter.page = event;
    this.getData();
  }

  onChangeSize(event: any) {
    this.filter.limit = event;
    this.getData();
  }

  edit(item: any) {
    const modalRef = this.modalService.create({
      nzContent: ItemComponent,
      nzWidth: '50vw',
      nzClassName: 'modal-country',
      nzData: {
        mode: ItemMode.Edit,
        formConfig: this.formConfig,
        data: item,
        collection: 'country'
      },
    });
    modalRef.afterClose.subscribe(result => {
      if (result) {
        this.noti.create('success', '',
          this.translate.instant('updateSuccess', {value: (this.translate.instant('country.label'))}));
        this.getData();
      }
    });
  }

  view(item: any) {
    const modalRef = this.modalService.create({
      nzContent: ItemComponent,
      nzWidth: '50vw',
      nzClassName: 'modal-country',
      nzData: {
        mode: ItemMode.View,
        formConfig: this.formConfig,
        data: item,
        collection: 'country'
      },
    });
    modalRef.afterClose.subscribe(result => {
      if (result) {
        this.noti.create('success', '',
          this.translate.instant('updateSuccess', {value: (this.translate.instant('country.label'))}));
        this.getData();
      }
    });
  }

  add() {
    const modalRef = this.modalService.create({
      nzContent: ItemComponent,
      nzWidth: '50vw',
      nzClassName: 'modal-country',
      nzData: {
        mode: ItemMode.Add,
        formConfig: this.formConfig,
        collection: 'country'
      },
    });
    modalRef.afterClose.subscribe(result => {
      if (result) {
        this.noti.create('success', '',
          this.translate.instant('addSuccess', {value: (this.translate.instant('country.label'))}));
        this.getData();
      }
    });
  }

  delete(item: any) {
    this.service.delete('country', item.id).then(res => {
      this.noti.create('success', '',
        this.translate.instant('deleteSuccess', {value: (this.translate.instant('country.label'))}));
      this.getData();
    }).catch((error: any) => {
      this.service.handleError(error)
    });
  }

  export() {
    this.service.search('country', {
      fields: ['*', 'user_created.*', 'user_updated.*'],
      filter: formatFilter(this.filter, this.formFilterConfig),
    }).then(dataResult => {
      const configColumn: ColumnConfigExport[] = this.formConfig.map((item: any) => {
        switch (item.type) {
          case 'date':
            return { headerText: item.title, field: item.name, type: 'date' };
          case 'number':
            return { headerText: item.title, field: item.name, type: 'number' };
          case 'dropdown':
          case 'status':
            return { headerText: item.title, field: item.name, type: 'dropdown', options: item.options };
          default:
            return { headerText: item.title, field: item.name, type: 'text' };
        }
      })
      let dataExport: any[] = [];
      if (dataResult?.length > 0) {
        dataExport = dataResult.map(item => {
          item['creator'] = item['user_created'] ? [item['user_created']['first_name'], item['user_created']['last_name']].join(' ') : undefined;
          item['updater'] = item['user_updated'] ? [item['user_updated']['first_name'], item['user_updated']['last_name']].join(' ') : undefined;
          return item;
        })
      }
      const listExport = formatDataExport(dataExport, configColumn, this.translate);
      exportAsExcelFile(listExport, this.translate.instant('country.title') + '_' + this.datePipe.transform(new Date(), 'yyMMdd'), this.noti, this.translate);
    }, (error: any) => {
      this.service.handleError(error)
    }).catch((error: any) => {
      this.service.handleError(error)
    });
  }

  onSort(event: any) {
    this.formConfig.forEach((col) => {
      if (col['name'] === event) {
        this.filter['sort'] = col['sortBy'] === 'ASC' ? event : '-' + event;
        col['sortBy'] = col['sortBy'] === 'ASC' ? 'DESC' : 'ASC';
      } else {
        col['sortBy'] = 'ASC'
      }
    });
    this.getData();
  }
}
